import { render, staticRenderFns } from "./TranslationCreate.vue?vue&type=template&id=66cc5630&"
import script from "./TranslationCreate.vue?vue&type=script&lang=js&"
export * from "./TranslationCreate.vue?vue&type=script&lang=js&"
import style0 from "./TranslationCreate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports